import * as z from "zod";
//#region src/__generated__/external/application/zod/createRequestBodySchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const createRequestBodySchema = z.object({
	additionalData: z.string().optional().describe("Дополнительные данные").meta({ examples: ["Комментарий к заявке"] }),
	adjoiningType: z.enum(["DIRECT_RZD", "VIA_OTHER_OWNER"]).optional().describe("Тип примыкания"),
	applicantAddress: z.string().optional().describe("Адрес"),
	applicantEmail: z.string().optional().describe("Контактная почта заявителя"),
	applicantInn: z.string().optional().describe("ИНН"),
	applicantKpp: z.string().optional().describe("КПП"),
	applicantName: z.string().optional().describe("Наименование организации или ФИО"),
	applicantOkpo: z.string().optional().describe("ОКПО"),
	applicantPhone: z.string().optional().describe("Контактный телефон заявителя"),
	applicantType: z.enum([
		"INDIVIDUAL",
		"SOLE_PROPRIETOR",
		"LEGAL_ENTITY"
	]).optional().describe("Тип заявителя"),
	plannedWorksType: z.enum([
		"NEW_TRACK_CONSTRUCTION",
		"RECONSTRUCTION",
		"RESTORATION",
		"DEVELOPMENT"
	]).optional().describe("Вид планируемых работ"),
	railway: z.enum([
		"VOSTOCHNO_SIBIRSKAYA",
		"GORKOVSKAYA",
		"DALNEVOSTOCHNAYA",
		"ZABAYKALSKAYA",
		"ZAPADNO_SIBIRSKAYA",
		"KALININGRADSKAYA",
		"KRASNOYARSKAYA",
		"KUYBYSHEVSKAYA",
		"MOSKOVSKAYA",
		"OKTYABRSKAYA",
		"PRIVOLZHSKAYA",
		"SVERDLOVSKAYA",
		"SEVERNAYA",
		"SEVERO_KAVKAZSKAYA",
		"YUGO_VOSTOCHNAYA",
		"YUZHNO_URALSKAYA"
	]).optional().describe("Железная дорога"),
	requestSubject: z.enum(["ADJOINING", "CROSSING"]).optional().describe("Вид обращения (примыкание/пересечение)"),
	section: z.string().optional().describe("Участок (станция/перегон); необязателен при создании и submit"),
	title: z.string().min(1).describe("Заголовок заявки").meta({ examples: ["Заявка на выдачу ТУ"] }),
	trackFunding: z.enum([
		"APPLICANT_FUNDS",
		"RZD_INVESTMENT",
		"SHARED",
		"OTHER"
	]).optional().describe("Функциональное назначение пути"),
	type: z.enum([
		"TU_ISSUE",
		"TU_CHANGE",
		"APPROVAL"
	]).describe("Тип заявки").meta({ examples: ["TU_ISSUE"] })
}).describe("Тело запроса на создание заявки");
//#endregion
//#region src/__generated__/external/application/zod/requestCreatedResponseSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const requestCreatedResponseSchema = z.object({
	id: z.uuid().nullish().describe("Идентификатор заявки").meta({ examples: ["550e8400-e29b-41d4-a716-446655440000"] }),
	number: z.int().nullish().describe("Номер заявки").meta({ examples: [1001] })
}).describe("Ответ на создание заявки");
//#endregion
//#region src/__generated__/external/application/zod/createRequestSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const createRequestStatus200Schema = requestCreatedResponseSchema.describe("Ответ на создание заявки");
const createRequestResponseSchema = createRequestStatus200Schema;
const createRequestDataSchema = createRequestBodySchema.describe("Тело запроса на создание заявки");
//#endregion
//#region src/__generated__/external/application/zod/deleteAttachmentDescriptionSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const deleteAttachmentDescriptionPathIdSchema = z.uuid();
const deleteAttachmentDescriptionPathFileIdSchema = z.uuid();
const deleteAttachmentDescriptionStatus204Schema = z.unknown();
const deleteAttachmentDescriptionResponseSchema = deleteAttachmentDescriptionStatus204Schema;
//#endregion
//#region src/__generated__/external/application/zod/deleteRequestSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const deleteRequestPathIdSchema = z.uuid();
const deleteRequestStatus204Schema = z.unknown();
const deleteRequestResponseSchema = deleteRequestStatus204Schema;
//#endregion
//#region src/__generated__/external/application/zod/requestExportRequestSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const requestExportRequestSchema = z.object({ ids: z.array(z.uuid()).min(1).describe("Идентификаторы заявок для экспорта") }).describe("Тело запроса на пакетный экспорт заявок в один архив");
//#endregion
//#region src/__generated__/external/application/zod/exportRequestsSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const exportRequestsStatus200Schema = z.object({}).catchall(z.unknown());
const exportRequestsResponseSchema = exportRequestsStatus200Schema;
const exportRequestsDataSchema = requestExportRequestSchema.describe("Тело запроса на пакетный экспорт заявок в один архив");
//#endregion
//#region src/__generated__/external/application/zod/filterValueItemSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const filterValueItemSchema = z.object({
	displayName: z.string().nullish().describe("Отображаемое название"),
	value: z.string().nullish().describe("Значение для передачи в фильтр")
}).describe("Доступное значение фильтра");
//#endregion
//#region src/__generated__/external/application/zod/getApplicantNamesSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getApplicantNamesQueryQSchema = z.string().optional();
const getApplicantNamesQueryLimitSchema = z.int().optional();
const getApplicantNamesQuerySelectedSchema = z.array(z.string()).optional();
const getApplicantNamesStatus200Schema = z.array(filterValueItemSchema);
const getApplicantNamesResponseSchema = getApplicantNamesStatus200Schema;
//#endregion
//#region src/__generated__/external/application/zod/tileCountSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const tileCountSchema = z.object({
	count: z.int().nullish().describe("Значение счётчика"),
	key: z.enum([
		"TOTAL",
		"DRAFT",
		"IN_REVIEW",
		"REVISION_REQUIRED",
		"WAITING_PAYMENT",
		"RESOLVED_APPROVED",
		"RESOLVED_REJECTED",
		"NEEDS_EXPORT",
		"EXPORTED",
		"LOADED"
	]).optional().describe("Ключ плашки")
}).describe("Ролевая плашка (таб) реестра");
//#endregion
//#region src/__generated__/external/application/zod/requestStatusCountsSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const requestStatusCountsSchema = z.object({
	byStatus: z.object({}).catchall(z.int()).nullish().describe("Количество по каждому статусу"),
	needsAttention: z.int().nullish().describe("Требующие внимания: WAITING_PAYMENT + REVISION_REQUIRED").meta({ examples: [4] }),
	tiles: z.array(tileCountSchema).nullish().describe("Ролевые плашки (табы) реестра; набор определяется ролью/эндпоинтом"),
	total: z.int().nullish().describe("Всего заявок (без удалённых)").meta({ examples: [28] })
}).describe("Счётчики заявок по статусам для текущего пользователя");
//#endregion
//#region src/__generated__/external/application/zod/getCountsSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getCountsStatus200Schema = requestStatusCountsSchema.describe("Счётчики заявок по статусам для текущего пользователя");
const getCountsResponseSchema = getCountsStatus200Schema;
//#endregion
//#region src/__generated__/external/application/zod/emptyPayloadSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const emptyPayloadSchema = z.unknown().describe("Событие без дополнительных параметров");
//#endregion
//#region src/__generated__/external/application/zod/invoiceImportPayloadSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const invoiceImportPayloadSchema = z.object({
	amount: z.number().nullish().describe("Сумма счёта").meta({ examples: [15e3] }),
	externalRequestId: z.uuid().nullish().describe("Идентификатор заявки во внешнем контуре"),
	invoiceNumber: z.string().nullish().describe("Номер счёта"),
	number: z.int().nullish().describe("Номер заявки")
}).describe("Импорт счёта на оплату");
//#endregion
//#region src/__generated__/external/application/zod/operatorActorDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const operatorActorDtoSchema = z.object({
	contactPhone: z.string().nullish().describe("Контактный телефон").meta({ examples: ["+7 900 000-00-00"] }),
	corporateEmail: z.string().nullish().describe("Корпоративная почта").meta({ examples: ["petrov@romashka.ru"] }),
	email: z.string().nullish().describe("Email учётной записи. Заполняется только для сотрудников Оператора: у них нет\nпрофиля ВТУ, поэтому это единственный контакт.\n").meta({ examples: ["petrov@example.com"] }),
	firstName: z.string().nullish().describe("Имя").meta({ examples: ["Пётр"] }),
	lastName: z.string().nullish().describe("Фамилия").meta({ examples: ["Петров"] }),
	middleName: z.string().nullish().describe("Отчество").meta({ examples: ["Петрович"] }),
	organization: z.string().nullish().describe("Организация").meta({ examples: ["ООО «Ромашка»"] }),
	position: z.string().nullish().describe("Должность").meta({ examples: ["Главный инженер"] }),
	userId: z.uuid().nullish().describe("Идентификатор пользователя в Keycloak")
}).describe("Пользователь, выполнивший действие: оператор (выгрузка/загрузка) либо заявитель\n(действия в журнале заявки). Регистрационные данные — из Keycloak, рабочие —\nиз профиля ВТУ. Рабочие данные заполнены только у заявителей: у оператора\nпрофиля во внешнем контуре нет, поэтому у него они всегда null.\n");
//#endregion
//#region src/__generated__/external/application/zod/proofUploadPayloadSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const proofUploadPayloadSchema = z.object({ fileName: z.string().nullish().describe("Имя загруженного файла") }).describe("Загрузка подтверждения оплаты");
//#endregion
//#region src/__generated__/external/application/zod/resultImportPayloadSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const resultImportPayloadSchema = z.object({
	commentsImported: z.int().nullish().describe("Сколько комментариев импортировано"),
	externalRequestId: z.uuid().nullish().describe("Идентификатор заявки во внешнем контуре"),
	filesImported: z.int().nullish().describe("Сколько файлов результата импортировано"),
	number: z.int().nullish().describe("Номер заявки"),
	outcome: z.enum([
		"REVISION_REQUIRED",
		"APPROVED",
		"REJECTED"
	]).optional().describe("Исход рассмотрения")
}).describe("Импорт результата рассмотрения");
//#endregion
//#region src/__generated__/external/application/zod/requestEventLogDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const requestEventLogDtoSchema = z.object({
	actor: z.uuid().nullish().describe("Идентификатор инициатора действия (Keycloak subject)"),
	actorFirstName: z.string().nullish().describe("Имя инициатора на момент события").meta({ examples: ["Пётр"] }),
	actorInfo: operatorActorDtoSchema.nullish().describe("Бейдж инициатора действия."),
	actorLastName: z.string().nullish().describe("Фамилия инициатора на момент события").meta({ examples: ["Петров"] }),
	actorMiddleName: z.string().nullish().describe("Отчество инициатора на момент события").meta({ examples: ["Петрович"] }),
	actorRole: z.string().nullish().describe("Роль инициатора").meta({ examples: ["ВНЕШНЕЕ СОГЛАСОВАНИЕ ОПЕРАТОР"] }),
	eventType: z.enum([
		"SUBMIT",
		"EDIT",
		"DELETE",
		"REJECT",
		"EXPORT",
		"IMPORT_RESULT",
		"INVOICE_IMPORTED",
		"PAYMENT_PROOF_UPLOADED",
		"PAYMENT_PROOF_DELETED",
		"PAYMENT_NOTIFIED"
	]).optional().describe("Тип события; определяет форму payload"),
	id: z.uuid().nullish().describe("Идентификатор записи журнала"),
	occurredAt: z.iso.datetime().nullish().describe("Время события").meta({ examples: ["2026-04-16T11:00:00Z"] }),
	payload: z.union([
		resultImportPayloadSchema.strict(),
		invoiceImportPayloadSchema.strict(),
		proofUploadPayloadSchema.strict(),
		emptyPayloadSchema
	]).nullish().describe("Дополнительные параметры события; форма определяется eventType")
}).describe("Запись журнала действий по заявке");
//#endregion
//#region src/__generated__/external/application/zod/getHistorySchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getHistoryPathIdSchema = z.uuid();
const getHistoryStatus200Schema = z.array(requestEventLogDtoSchema);
const getHistoryResponseSchema = getHistoryStatus200Schema;
//#endregion
//#region src/__generated__/external/application/zod/pageResponseSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const pageResponseSchema = z.object({
	content: z.array(z.unknown()).nullish().describe("Элементы страницы"),
	page: z.int().nullish().describe("Номер текущей страницы (0-based)").meta({ examples: [0] }),
	size: z.int().nullish().describe("Размер страницы").meta({ examples: [20] }),
	totalElements: z.int().nullish().describe("Общее количество элементов").meta({ examples: [142] }),
	totalPages: z.int().nullish().describe("Общее количество страниц").meta({ examples: [8] })
}).describe("Пагинированный ответ");
//#endregion
//#region src/__generated__/external/application/zod/getNeedsAttentionSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getNeedsAttentionQuerySearchSchema = z.string().optional();
const getNeedsAttentionQueryPageSchema = z.int().optional();
const getNeedsAttentionQuerySizeSchema = z.int().optional();
const getNeedsAttentionStatus200Schema = pageResponseSchema.describe("Пагинированный ответ");
const getNeedsAttentionResponseSchema = getNeedsAttentionStatus200Schema;
//#endregion
//#region src/__generated__/external/application/zod/getOperatorCountsSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getOperatorCountsStatus200Schema = requestStatusCountsSchema.describe("Счётчики заявок по статусам для текущего пользователя");
const getOperatorCountsResponseSchema = getOperatorCountsStatus200Schema;
//#endregion
//#region src/__generated__/external/application/zod/getOperatorFilterValuesSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getOperatorFilterValuesQueryColumnSchema = z.enum(["OPERATOR", "INITIATOR"]).describe("Колонка, для которой запрашиваются доступные значения фильтра");
const getOperatorFilterValuesQueryQSchema = z.string().optional();
const getOperatorFilterValuesQueryLimitSchema = z.int().optional();
const getOperatorFilterValuesQuerySelectedSchema = z.array(z.uuid()).optional();
const getOperatorFilterValuesStatus200Schema = z.array(filterValueItemSchema);
const getOperatorFilterValuesResponseSchema = getOperatorFilterValuesStatus200Schema;
//#endregion
//#region src/__generated__/external/application/zod/externalApplicantDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const externalApplicantDtoSchema = z.object({
	contactPhone: z.string().nullish().describe("Контактный телефон").meta({ examples: ["+7 900 000-00-00"] }),
	corporateEmail: z.string().nullish().describe("Корпоративная почта").meta({ examples: ["ivanov@romashka.ru"] }),
	externalUserId: z.uuid().nullish().describe("Subject заявителя в Keycloak").meta({ examples: ["5d75c6c0-b526-4e34-b6ee-f48140be2f90"] }),
	firstName: z.string().nullish().describe("Имя").meta({ examples: ["Иван"] }),
	lastName: z.string().nullish().describe("Фамилия").meta({ examples: ["Иванов"] }),
	middleName: z.string().nullish().describe("Отчество").meta({ examples: ["Иванович"] }),
	organization: z.string().nullish().describe("Организация").meta({ examples: ["ООО «Ромашка»"] }),
	position: z.string().nullish().describe("Должность").meta({ examples: ["Главный инженер"] })
}).describe("Бейдж заявителя: ФИО из Keycloak плюс рабочие данные из профиля ВТУ.\nРабочие данные заявитель заполняет сам, поэтому любое из них может быть null.\n");
//#endregion
//#region src/__generated__/external/application/zod/requestListItemSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const requestListItemSchema = z.object({
	additionalData: z.string().nullish().describe("Дополнительные данные").meta({ examples: ["Комментарий к заявке"] }),
	applicant: externalApplicantDtoSchema.nullish().describe("Заявитель (null если профиль недоступен в Keycloak)"),
	applicantName: z.string().nullish().describe("Наименование организации или ФИО заявителя"),
	applicantType: z.enum([
		"INDIVIDUAL",
		"SOLE_PROPRIETOR",
		"LEGAL_ENTITY"
	]).optional().describe("Тип заявителя"),
	createdAt: z.iso.datetime().nullish().describe("Дата создания заявки").meta({ examples: ["2026-04-16T10:30:00Z"] }),
	displayStatus: z.string().nullish().describe("Отображаемый статус заявки").meta({ examples: ["Черновик"] }),
	id: z.uuid().nullish().describe("Идентификатор заявки").meta({ examples: ["550e8400-e29b-41d4-a716-446655440000"] }),
	initiator: externalApplicantDtoSchema.nullish().describe("Заявитель, создавший заявку"),
	needsExport: z.boolean().nullish().describe("УСТАРЕЛО: дублирует processingFlag == NEEDS_EXPORT, будет удалено. Признак: заявка требует выгрузки в другой контур"),
	number: z.int().nullish().describe("Номер заявки").meta({ examples: [1001] }),
	objectDescription: z.object({}).catchall(z.unknown()).nullish().describe("Описание объекта (произвольный JSON-объект)").meta({ examples: [{}] }),
	operator: operatorActorDtoSchema.nullish().describe("Пользователь, выполнивший выгрузку/загрузку (null для \"Требуется выгрузка\")"),
	paymentCondition: z.enum([
		"UNDER_REVIEW",
		"NO_PAYMENT",
		"PAID"
	]).optional().describe("Условие оплаты, установленное Аппаратом НГ"),
	processedAt: z.iso.datetime().nullish().describe("Дата обработки (только для \"Выгружено\"/\"Загружено\", иначе null)"),
	processingFlag: z.enum([
		"TOTAL",
		"DRAFT",
		"IN_REVIEW",
		"REVISION_REQUIRED",
		"WAITING_PAYMENT",
		"RESOLVED_APPROVED",
		"RESOLVED_REJECTED",
		"NEEDS_EXPORT",
		"EXPORTED",
		"LOADED"
	]).optional().describe("Признак обработки заявки Оператором"),
	railway: z.enum([
		"VOSTOCHNO_SIBIRSKAYA",
		"GORKOVSKAYA",
		"DALNEVOSTOCHNAYA",
		"ZABAYKALSKAYA",
		"ZAPADNO_SIBIRSKAYA",
		"KALININGRADSKAYA",
		"KRASNOYARSKAYA",
		"KUYBYSHEVSKAYA",
		"MOSKOVSKAYA",
		"OKTYABRSKAYA",
		"PRIVOLZHSKAYA",
		"SVERDLOVSKAYA",
		"SEVERNAYA",
		"SEVERO_KAVKAZSKAYA",
		"YUGO_VOSTOCHNAYA",
		"YUZHNO_URALSKAYA"
	]).optional().describe("Железная дорога"),
	receivedAt: z.iso.datetime().nullish().describe("Дата поступления (только для признака \"Требуется выгрузка\", иначе null)"),
	requestSubject: z.enum(["ADJOINING", "CROSSING"]).optional().describe("Вид обращения (Примыкание/Пересечение)"),
	section: z.string().nullish().describe("Участок"),
	status: z.enum([
		"DRAFT",
		"IN_REVIEW",
		"REVISION_REQUIRED",
		"WAITING_PAYMENT",
		"RESOLVED_APPROVED",
		"RESOLVED_REJECTED"
	]).optional().describe("Статус заявки").meta({ examples: ["DRAFT"] }),
	title: z.string().nullish().describe("Заголовок заявки").meta({ examples: ["Заявка на выдачу ТУ"] }),
	type: z.enum([
		"TU_ISSUE",
		"TU_CHANGE",
		"APPROVAL"
	]).optional().describe("Тип заявки").meta({ examples: ["TU_ISSUE"] }),
	updatedAt: z.iso.datetime().nullish().describe("Дата последнего изменения заявки").meta({ examples: ["2026-04-16T10:35:00Z"] })
}).describe("Элемент списка заявок");
//#endregion
//#region src/__generated__/external/application/zod/pageResponseRequestListItemSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const pageResponseRequestListItemSchema = z.object({
	content: z.array(requestListItemSchema).nullish().describe("Элементы страницы"),
	page: z.int().nullish().describe("Номер текущей страницы (0-based)").meta({ examples: [0] }),
	size: z.int().nullish().describe("Размер страницы").meta({ examples: [20] }),
	totalElements: z.int().nullish().describe("Общее количество элементов").meta({ examples: [142] }),
	totalPages: z.int().nullish().describe("Общее количество страниц").meta({ examples: [8] })
}).describe("Пагинированный ответ");
//#endregion
//#region src/__generated__/external/application/zod/getOperatorRequestsSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getOperatorRequestsQuerySearchSchema = z.string().optional().describe("Поисковая подстрока по title; дополнительно префикс по number");
const getOperatorRequestsQueryStatusSchema = z.array(z.enum([
	"DRAFT",
	"IN_REVIEW",
	"REVISION_REQUIRED",
	"WAITING_PAYMENT",
	"RESOLVED_APPROVED",
	"RESOLVED_REJECTED"
])).optional().describe("Фильтр по статусам (повторяемый параметр)");
const getOperatorRequestsQueryProcessingFlagSchema = z.array(z.enum([
	"TOTAL",
	"DRAFT",
	"IN_REVIEW",
	"REVISION_REQUIRED",
	"WAITING_PAYMENT",
	"RESOLVED_APPROVED",
	"RESOLVED_REJECTED",
	"NEEDS_EXPORT",
	"EXPORTED",
	"LOADED"
])).optional().describe("Признак обработки (повторяемый параметр); допустимы только NEEDS_EXPORT, EXPORTED, LOADED");
const getOperatorRequestsQueryRailwaySchema = z.array(z.enum([
	"VOSTOCHNO_SIBIRSKAYA",
	"GORKOVSKAYA",
	"DALNEVOSTOCHNAYA",
	"ZABAYKALSKAYA",
	"ZAPADNO_SIBIRSKAYA",
	"KALININGRADSKAYA",
	"KRASNOYARSKAYA",
	"KUYBYSHEVSKAYA",
	"MOSKOVSKAYA",
	"OKTYABRSKAYA",
	"PRIVOLZHSKAYA",
	"SVERDLOVSKAYA",
	"SEVERNAYA",
	"SEVERO_KAVKAZSKAYA",
	"YUGO_VOSTOCHNAYA",
	"YUZHNO_URALSKAYA"
])).optional().describe("Фильтр по железным дорогам (повторяемый параметр)");
const getOperatorRequestsQueryOperatorIdSchema = z.array(z.uuid()).optional().describe("Оператор, выполнивший выгрузку — id пользователей (повторяемый параметр)");
const getOperatorRequestsQueryInitiatorIdSchema = z.array(z.uuid()).optional().describe("Инициатор заявки — id пользователей (повторяемый параметр)");
const getOperatorRequestsQueryReceivedFromSchema = z.iso.datetime().optional().describe("Дата поступления: начало периода включительно, ISO-8601 instant. Для фильтра «конкретная дата» фронт присылает границы своего дня");
const getOperatorRequestsQueryReceivedToSchema = z.iso.datetime().optional().describe("Дата поступления: конец периода включительно");
const getOperatorRequestsQueryProcessedFromSchema = z.iso.datetime().optional().describe("Дата обработки: начало периода включительно");
const getOperatorRequestsQueryProcessedToSchema = z.iso.datetime().optional().describe("Дата обработки: конец периода включительно");
const getOperatorRequestsQuerySortBySchema = z.enum([
	"NUMBER",
	"TITLE",
	"STATUS",
	"RECEIVED_AT",
	"PROCESSING_FLAG",
	"PROCESSED_AT",
	"RAILWAY",
	"OPERATOR",
	"INITIATOR"
]).optional().describe("Поле сортировки; без него — created_at DESC");
const getOperatorRequestsQuerySortDirSchema = z.enum(["ASC", "DESC"]).optional().describe("Направление сортировки");
const getOperatorRequestsQueryPageSchema = z.int().optional().describe("Номер страницы (с 0)");
const getOperatorRequestsQuerySizeSchema = z.int().optional().describe("Размер страницы");
const getOperatorRequestsStatus200Schema = pageResponseRequestListItemSchema.describe("Пагинированный ответ");
const getOperatorRequestsResponseSchema = getOperatorRequestsStatus200Schema;
//#endregion
//#region src/__generated__/external/application/zod/finalDecisionAuthorResponseSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const finalDecisionAuthorResponseSchema = z.object({
	firstName: z.string().nullish(),
	id: z.uuid().nullish(),
	lastName: z.string().nullish(),
	middleName: z.string().nullish()
}).describe("Снимок автора мотивированного отказа");
//#endregion
//#region src/__generated__/external/application/zod/finalDecisionDocumentResponseSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const finalDecisionDocumentResponseSchema = z.object({
	fileId: z.uuid().nullish(),
	name: z.string().nullish()
}).describe("Опубликованный документ итогового решения.");
//#endregion
//#region src/__generated__/external/application/zod/finalDecisionResponseSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const finalDecisionResponseSchema = z.object({
	author: finalDecisionAuthorResponseSchema.nullish().describe("Снимок автора мотивированного отказа"),
	decidedAt: z.iso.datetime().nullish(),
	decision: z.enum(["APPROVED", "REJECTED"]).optional().describe("Решение по заявке"),
	documents: z.array(finalDecisionDocumentResponseSchema).nullish(),
	justification: z.string().nullish(),
	versionNumber: z.int().nullish()
}).describe("Опубликованная согласованная версия итогового решения.");
//#endregion
//#region src/__generated__/external/application/zod/requestDetailResponseSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const requestDetailResponseSchema = z.object({
	additionalData: z.string().nullish().describe("Дополнительные данные").meta({ examples: ["Комментарий к заявке"] }),
	adjoiningType: z.enum(["DIRECT_RZD", "VIA_OTHER_OWNER"]).optional().describe("Тип примыкания"),
	applicant: externalApplicantDtoSchema.nullish().describe("Заявитель (null если профиль недоступен в Keycloak)"),
	applicantAddress: z.string().nullish().describe("Адрес заявителя"),
	applicantEmail: z.string().nullish().describe("Контактная почта заявителя"),
	applicantInn: z.string().nullish().describe("ИНН заявителя"),
	applicantKpp: z.string().nullish().describe("КПП заявителя"),
	applicantName: z.string().nullish().describe("Наименование организации или ФИО заявителя"),
	applicantOkpo: z.string().nullish().describe("ОКПО заявителя"),
	applicantPhone: z.string().nullish().describe("Контактный телефон заявителя"),
	applicantType: z.enum([
		"INDIVIDUAL",
		"SOLE_PROPRIETOR",
		"LEGAL_ENTITY"
	]).optional().describe("Тип заявителя"),
	createdAt: z.iso.datetime().nullish().describe("Дата создания заявки").meta({ examples: ["2026-04-16T10:30:00Z"] }),
	displayStatus: z.string().nullish().describe("Отображаемый статус заявки").meta({ examples: ["Черновик"] }),
	finalDecision: finalDecisionResponseSchema.nullish().describe("Опубликованное итоговое решение; null до атомарного завершения публикации."),
	id: z.uuid().nullish().describe("Идентификатор заявки").meta({ examples: ["550e8400-e29b-41d4-a716-446655440000"] }),
	initiator: externalApplicantDtoSchema.nullish().describe("Заявитель, создавший заявку"),
	needsExport: z.boolean().nullish().describe("УСТАРЕЛО: дублирует processingFlag == NEEDS_EXPORT, будет удалено. Признак: заявка требует выгрузки в другой контур"),
	number: z.int().nullish().describe("Номер заявки").meta({ examples: [1001] }),
	objectDescription: z.object({}).catchall(z.unknown()).nullish().describe("Описание объекта (произвольный JSON-объект)").meta({ examples: [{}] }),
	operator: operatorActorDtoSchema.nullish().describe("Пользователь, выполнивший выгрузку/загрузку (null для \"Требуется выгрузка\")"),
	operatorState: z.string().nullish().describe("Состояние обработки оператором").meta({ examples: ["PENDING"] }),
	paymentCondition: z.enum([
		"UNDER_REVIEW",
		"NO_PAYMENT",
		"PAID"
	]).optional().describe("Условие оплаты, установленное Аппаратом НГ"),
	plannedWorksType: z.enum([
		"NEW_TRACK_CONSTRUCTION",
		"RECONSTRUCTION",
		"RESTORATION",
		"DEVELOPMENT"
	]).optional().describe("Вид планируемых работ"),
	processedAt: z.iso.datetime().nullish().describe("Дата обработки (только для \"Выгружено\"/\"Загружено\", иначе null)"),
	processingFlag: z.enum([
		"TOTAL",
		"DRAFT",
		"IN_REVIEW",
		"REVISION_REQUIRED",
		"WAITING_PAYMENT",
		"RESOLVED_APPROVED",
		"RESOLVED_REJECTED",
		"NEEDS_EXPORT",
		"EXPORTED",
		"LOADED"
	]).optional().describe("Признак обработки заявки Оператором"),
	railway: z.enum([
		"VOSTOCHNO_SIBIRSKAYA",
		"GORKOVSKAYA",
		"DALNEVOSTOCHNAYA",
		"ZABAYKALSKAYA",
		"ZAPADNO_SIBIRSKAYA",
		"KALININGRADSKAYA",
		"KRASNOYARSKAYA",
		"KUYBYSHEVSKAYA",
		"MOSKOVSKAYA",
		"OKTYABRSKAYA",
		"PRIVOLZHSKAYA",
		"SVERDLOVSKAYA",
		"SEVERNAYA",
		"SEVERO_KAVKAZSKAYA",
		"YUGO_VOSTOCHNAYA",
		"YUZHNO_URALSKAYA"
	]).optional().describe("Железная дорога"),
	receivedAt: z.iso.datetime().nullish().describe("Дата поступления (только для признака \"Требуется выгрузка\", иначе null)"),
	requestSubject: z.enum(["ADJOINING", "CROSSING"]).optional().describe("Вид обращения (примыкание/пересечение)"),
	resolvedAt: z.iso.datetime().nullish().describe("Дата принятия решения по заявке").meta({ examples: ["2026-04-20T15:30:00Z"] }),
	resultFileId: z.uuid().nullish().describe("ID результирующего документа в file-service. Заполняется после импорта результата, если в архиве был TU_RESULT. null до резолюции и если исход опубликован документами итогового решения."),
	section: z.string().nullish().describe("Участок"),
	status: z.enum([
		"DRAFT",
		"IN_REVIEW",
		"REVISION_REQUIRED",
		"WAITING_PAYMENT",
		"RESOLVED_APPROVED",
		"RESOLVED_REJECTED"
	]).optional().describe("Статус заявки").meta({ examples: ["DRAFT"] }),
	submittedAt: z.iso.datetime().nullish().describe("Дата отправки заявки").meta({ examples: ["2026-04-16T11:00:00Z"] }),
	title: z.string().nullish().describe("Заголовок заявки").meta({ examples: ["Заявка на выдачу ТУ"] }),
	trackFunding: z.enum([
		"APPLICANT_FUNDS",
		"RZD_INVESTMENT",
		"SHARED",
		"OTHER"
	]).optional().describe("Функциональное назначение пути"),
	type: z.enum([
		"TU_ISSUE",
		"TU_CHANGE",
		"APPROVAL"
	]).optional().describe("Тип заявки").meta({ examples: ["TU_ISSUE"] }),
	updatedAt: z.iso.datetime().nullish().describe("Дата последнего изменения заявки").meta({ examples: ["2026-04-16T10:35:00Z"] })
}).describe("Детальная информация о заявке");
//#endregion
//#region src/__generated__/external/application/zod/getRequestSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getRequestPathIdSchema = z.uuid();
const getRequestStatus200Schema = requestDetailResponseSchema.describe("Детальная информация о заявке");
const getRequestResponseSchema = getRequestStatus200Schema;
//#endregion
//#region src/__generated__/external/application/zod/getRequestsSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getRequestsQuerySearchSchema = z.string().optional().describe("Поисковая подстрока по title; дополнительно префикс по number");
const getRequestsQueryStatusSchema = z.array(z.enum([
	"DRAFT",
	"IN_REVIEW",
	"REVISION_REQUIRED",
	"WAITING_PAYMENT",
	"RESOLVED_APPROVED",
	"RESOLVED_REJECTED"
])).optional().describe("Фильтр по статусам (повторяемый параметр)");
const getRequestsQueryPaymentConditionSchema = z.array(z.enum([
	"UNDER_REVIEW",
	"NO_PAYMENT",
	"PAID"
])).optional().describe("Условия оплаты (повторяемый параметр): UNDER_REVIEW на UI отображается как прочерк");
const getRequestsQueryRequestSubjectSchema = z.array(z.enum(["ADJOINING", "CROSSING"])).optional().describe("Фильтр по типу заявки — Примыкание/Пересечение (повторяемый параметр)");
const getRequestsQueryRailwaySchema = z.array(z.enum([
	"VOSTOCHNO_SIBIRSKAYA",
	"GORKOVSKAYA",
	"DALNEVOSTOCHNAYA",
	"ZABAYKALSKAYA",
	"ZAPADNO_SIBIRSKAYA",
	"KALININGRADSKAYA",
	"KRASNOYARSKAYA",
	"KUYBYSHEVSKAYA",
	"MOSKOVSKAYA",
	"OKTYABRSKAYA",
	"PRIVOLZHSKAYA",
	"SVERDLOVSKAYA",
	"SEVERNAYA",
	"SEVERO_KAVKAZSKAYA",
	"YUGO_VOSTOCHNAYA",
	"YUZHNO_URALSKAYA"
])).optional().describe("Фильтр по железным дорогам (повторяемый параметр)");
const getRequestsQueryApplicantNamesSchema = z.array(z.string()).optional().describe("Заявитель — точные значения из списка доступных (повторяемый параметр). Это наименование организации или ФИО адресата заявки, а не пользователь: один заявитель подаёт заявки от разных лиц");
const getRequestsQueryCreatedFromSchema = z.iso.datetime().optional().describe("Дата создания: начало периода включительно, ISO-8601 instant. Для фильтра «конкретная дата» фронт присылает границы своего дня: 00:00:00.000 и 23:59:59.999");
const getRequestsQueryCreatedToSchema = z.iso.datetime().optional().describe("Дата создания: конец периода включительно");
const getRequestsQueryUpdatedFromSchema = z.iso.datetime().optional().describe("Дата изменения: начало периода включительно");
const getRequestsQueryUpdatedToSchema = z.iso.datetime().optional().describe("Дата изменения: конец периода включительно");
const getRequestsQuerySortBySchema = z.enum([
	"NUMBER",
	"TITLE",
	"REQUEST_SUBJECT",
	"STATUS",
	"RAILWAY",
	"PAYMENT_CONDITION",
	"APPLICANT_NAME",
	"CREATED_AT",
	"UPDATED_AT"
]).optional().describe("Поле сортировки; без него — created_at DESC");
const getRequestsQuerySortDirSchema = z.enum(["ASC", "DESC"]).optional().describe("Направление сортировки");
const getRequestsQueryPageSchema = z.int().optional().describe("Номер страницы (с 0)");
const getRequestsQuerySizeSchema = z.int().optional().describe("Размер страницы");
const getRequestsStatus200Schema = pageResponseSchema.describe("Пагинированный ответ");
const getRequestsResponseSchema = getRequestsStatus200Schema;
//#endregion
//#region src/__generated__/external/application/zod/resultImportItemSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const resultImportItemSchema = z.object({
	commentsImported: z.int().nullish().describe("Сколько комментариев перенесено"),
	decision: z.string().nullish().describe("Решение из архива: APPROVED | REJECTED | REVISION_REQUIRED | null"),
	errors: z.array(z.string()).nullish().describe("Список ошибок, если outcome=FAILED"),
	externalRequestId: z.uuid().nullish().describe("Идентификатор заявки во внешнем контуре; null, если outcome.json не распарсился"),
	filesImported: z.int().nullish().describe("Сколько файлов результата загружено"),
	newStatus: z.string().nullish().describe("Статус заявки после применения результата"),
	number: z.int().nullish().describe("Номер заявки").meta({ examples: [1001] }),
	outcome: z.enum(["APPLIED", "FAILED"]).optional().describe("Исход: APPLIED | FAILED"),
	previousStatus: z.string().nullish().describe("Статус заявки до применения результата")
}).describe("Результат применения результата по одной заявке из архива");
//#endregion
//#region src/__generated__/external/application/zod/resultImportSummaryResponseSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const resultImportSummaryResponseSchema = z.object({
	applied: z.int().nullish().describe("Успешно применено результатов"),
	failed: z.int().nullish().describe("Пропущено некорректных заявок"),
	items: z.array(resultImportItemSchema).nullish().describe("Детализация по каждой заявке"),
	totalFound: z.int().nullish().describe("Всего заявок найдено в архиве")
}).describe("Сводка массового импорта результата");
//#endregion
//#region src/__generated__/external/application/zod/importResultSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const importResultStatus200Schema = resultImportSummaryResponseSchema.describe("Сводка массового импорта результата");
const importResultResponseSchema = importResultStatus200Schema;
const importResultDataSchema = z.object({ file: z.instanceof(File) }).optional();
//#endregion
//#region src/__generated__/external/application/zod/attachmentDescriptionDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const attachmentDescriptionDtoSchema = z.object({
	description: z.string().nullish().describe("Описание файла"),
	fileId: z.uuid().nullish().describe("Идентификатор файла в file-service")
}).describe("Описание приложенного файла");
//#endregion
//#region src/__generated__/external/application/zod/listAttachmentDescriptionsSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const listAttachmentDescriptionsPathIdSchema = z.uuid();
const listAttachmentDescriptionsStatus200Schema = z.array(attachmentDescriptionDtoSchema);
const listAttachmentDescriptionsResponseSchema = listAttachmentDescriptionsStatus200Schema;
//#endregion
//#region src/__generated__/external/application/zod/rejectRequestSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const rejectRequestPathIdSchema = z.uuid();
const rejectRequestStatus200Schema = requestDetailResponseSchema.describe("Детальная информация о заявке");
const rejectRequestResponseSchema = rejectRequestStatus200Schema;
//#endregion
//#region src/__generated__/external/application/zod/attachmentDescriptionBodySchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const attachmentDescriptionBodySchema = z.object({ description: z.string().min(0).max(2e3).optional().describe("Описание файла").meta({ examples: ["Схема примыкания, лист 1"] }) }).describe("Тело запроса на установку описания вложения");
//#endregion
//#region src/__generated__/external/application/zod/setAttachmentDescriptionSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const setAttachmentDescriptionPathIdSchema = z.uuid();
const setAttachmentDescriptionPathFileIdSchema = z.uuid();
const setAttachmentDescriptionStatus200Schema = attachmentDescriptionDtoSchema.describe("Описание приложенного файла");
const setAttachmentDescriptionResponseSchema = setAttachmentDescriptionStatus200Schema;
const setAttachmentDescriptionDataSchema = attachmentDescriptionBodySchema.describe("Тело запроса на установку описания вложения");
//#endregion
//#region src/__generated__/external/application/zod/submitRequestSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const submitRequestPathIdSchema = z.uuid();
const submitRequestStatus200Schema = requestDetailResponseSchema.describe("Детальная информация о заявке");
const submitRequestResponseSchema = submitRequestStatus200Schema;
//#endregion
//#region src/__generated__/external/application/zod/updateDraftRequestBodySchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const updateDraftRequestBodySchema = z.object({
	additionalData: z.string().optional().describe("Новая дополнительная информация; null — не менять, \"\" — очистить").meta({ examples: ["Уточнение по комментарию"] }),
	adjoiningType: z.enum(["DIRECT_RZD", "VIA_OTHER_OWNER"]).optional().describe("Тип примыкания"),
	applicantAddress: z.string().optional().describe("Адрес"),
	applicantEmail: z.string().optional().describe("Контактная почта заявителя"),
	applicantInn: z.string().optional().describe("ИНН"),
	applicantKpp: z.string().optional().describe("КПП"),
	applicantName: z.string().optional().describe("Наименование организации или ФИО"),
	applicantOkpo: z.string().optional().describe("ОКПО"),
	applicantPhone: z.string().optional().describe("Контактный телефон заявителя"),
	applicantType: z.enum([
		"INDIVIDUAL",
		"SOLE_PROPRIETOR",
		"LEGAL_ENTITY"
	]).optional().describe("Тип заявителя"),
	objectDescription: z.object({}).catchall(z.unknown()).optional().describe("Описание объекта (произвольный JSON-объект); null — не менять. Заменяется целиком.").meta({ examples: [{}] }),
	plannedWorksType: z.enum([
		"NEW_TRACK_CONSTRUCTION",
		"RECONSTRUCTION",
		"RESTORATION",
		"DEVELOPMENT"
	]).optional().describe("Вид планируемых работ"),
	railway: z.enum([
		"VOSTOCHNO_SIBIRSKAYA",
		"GORKOVSKAYA",
		"DALNEVOSTOCHNAYA",
		"ZABAYKALSKAYA",
		"ZAPADNO_SIBIRSKAYA",
		"KALININGRADSKAYA",
		"KRASNOYARSKAYA",
		"KUYBYSHEVSKAYA",
		"MOSKOVSKAYA",
		"OKTYABRSKAYA",
		"PRIVOLZHSKAYA",
		"SVERDLOVSKAYA",
		"SEVERNAYA",
		"SEVERO_KAVKAZSKAYA",
		"YUGO_VOSTOCHNAYA",
		"YUZHNO_URALSKAYA"
	]).optional().describe("Железная дорога"),
	requestSubject: z.enum(["ADJOINING", "CROSSING"]).optional().describe("Вид обращения (примыкание/пересечение)"),
	section: z.string().optional().describe("Участок (станция/перегон); необязателен при создании и submit."),
	title: z.string().regex(/^\S.*$/).optional().describe("Новый заголовок заявки; null — не менять").meta({ examples: ["Заявка на выдачу ТУ (исправлено)"] }),
	trackFunding: z.enum([
		"APPLICANT_FUNDS",
		"RZD_INVESTMENT",
		"SHARED",
		"OTHER"
	]).optional().describe("Функциональное назначение пути"),
	type: z.enum([
		"TU_ISSUE",
		"TU_CHANGE",
		"APPROVAL"
	]).optional().describe("Новый тип заявки; null — не менять").meta({ examples: ["TU_ISSUE"] })
}).describe("Тело запроса на редактирование черновика заявки. Поля с null остаются прежними; пустая строка для additionalData очищает поле.");
//#endregion
//#region src/__generated__/external/application/zod/updateDraftSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const updateDraftPathIdSchema = z.uuid();
const updateDraftStatus200Schema = requestDetailResponseSchema.describe("Детальная информация о заявке");
const updateDraftResponseSchema = updateDraftStatus200Schema;
const updateDraftDataSchema = updateDraftRequestBodySchema.describe("Тело запроса на редактирование черновика заявки. Поля с null остаются прежними; пустая строка для additionalData очищает поле.");
//#endregion
export { getOperatorRequestsQueryProcessedFromSchema as $, deleteRequestResponseSchema as $t, getRequestsQueryPageSchema as A, getHistoryResponseSchema as At, getRequestsQueryUpdatedToSchema as B, requestStatusCountsSchema as Bt, importResultResponseSchema as C, getNeedsAttentionQueryPageSchema as Ct, getRequestsQueryApplicantNamesSchema as D, getNeedsAttentionStatus200Schema as Dt, resultImportItemSchema as E, getNeedsAttentionResponseSchema as Et, getRequestsQuerySizeSchema as F, operatorActorDtoSchema as Ft, getRequestStatus200Schema as G, getApplicantNamesResponseSchema as Gt, getRequestsStatus200Schema as H, getApplicantNamesQueryLimitSchema as Ht, getRequestsQuerySortBySchema as I, invoiceImportPayloadSchema as It, finalDecisionDocumentResponseSchema as J, exportRequestsDataSchema as Jt, requestDetailResponseSchema as K, getApplicantNamesStatus200Schema as Kt, getRequestsQuerySortDirSchema as L, emptyPayloadSchema as Lt, getRequestsQueryRailwaySchema as M, requestEventLogDtoSchema as Mt, getRequestsQueryRequestSubjectSchema as N, resultImportPayloadSchema as Nt, getRequestsQueryCreatedFromSchema as O, pageResponseSchema as Ot, getRequestsQuerySearchSchema as P, proofUploadPayloadSchema as Pt, getOperatorRequestsQueryPageSchema as Q, deleteRequestPathIdSchema as Qt, getRequestsQueryStatusSchema as R, getCountsResponseSchema as Rt, importResultDataSchema as S, getOperatorCountsStatus200Schema as St, resultImportSummaryResponseSchema as T, getNeedsAttentionQuerySizeSchema as Tt, getRequestPathIdSchema as U, getApplicantNamesQueryQSchema as Ut, getRequestsResponseSchema as V, tileCountSchema as Vt, getRequestResponseSchema as W, getApplicantNamesQuerySelectedSchema as Wt, getOperatorRequestsQueryInitiatorIdSchema as X, exportRequestsStatus200Schema as Xt, finalDecisionAuthorResponseSchema as Y, exportRequestsResponseSchema as Yt, getOperatorRequestsQueryOperatorIdSchema as Z, requestExportRequestSchema as Zt, rejectRequestStatus200Schema as _, getOperatorFilterValuesQueryQSchema as _t, updateDraftRequestBodySchema as a, createRequestDataSchema as an, getOperatorRequestsQuerySearchSchema as at, listAttachmentDescriptionsStatus200Schema as b, getOperatorFilterValuesStatus200Schema as bt, submitRequestStatus200Schema as c, requestCreatedResponseSchema as cn, getOperatorRequestsQuerySortDirSchema as ct, setAttachmentDescriptionPathIdSchema as d, getOperatorRequestsStatus200Schema as dt, deleteRequestStatus204Schema as en, getOperatorRequestsQueryProcessedToSchema as et, setAttachmentDescriptionResponseSchema as f, pageResponseRequestListItemSchema as ft, rejectRequestResponseSchema as g, getOperatorFilterValuesQueryLimitSchema as gt, rejectRequestPathIdSchema as h, getOperatorFilterValuesQueryColumnSchema as ht, updateDraftStatus200Schema as i, deleteAttachmentDescriptionStatus204Schema as in, getOperatorRequestsQueryReceivedToSchema as it, getRequestsQueryPaymentConditionSchema as j, getHistoryStatus200Schema as jt, getRequestsQueryCreatedToSchema as k, getHistoryPathIdSchema as kt, setAttachmentDescriptionDataSchema as l, createRequestBodySchema as ln, getOperatorRequestsQueryStatusSchema as lt, attachmentDescriptionBodySchema as m, externalApplicantDtoSchema as mt, updateDraftPathIdSchema as n, deleteAttachmentDescriptionPathIdSchema as nn, getOperatorRequestsQueryRailwaySchema as nt, submitRequestPathIdSchema as o, createRequestResponseSchema as on, getOperatorRequestsQuerySizeSchema as ot, setAttachmentDescriptionStatus200Schema as p, requestListItemSchema as pt, finalDecisionResponseSchema as q, filterValueItemSchema as qt, updateDraftResponseSchema as r, deleteAttachmentDescriptionResponseSchema as rn, getOperatorRequestsQueryReceivedFromSchema as rt, submitRequestResponseSchema as s, createRequestStatus200Schema as sn, getOperatorRequestsQuerySortBySchema as st, updateDraftDataSchema as t, deleteAttachmentDescriptionPathFileIdSchema as tn, getOperatorRequestsQueryProcessingFlagSchema as tt, setAttachmentDescriptionPathFileIdSchema as u, getOperatorRequestsResponseSchema as ut, listAttachmentDescriptionsPathIdSchema as v, getOperatorFilterValuesQuerySelectedSchema as vt, importResultStatus200Schema as w, getNeedsAttentionQuerySearchSchema as wt, attachmentDescriptionDtoSchema as x, getOperatorCountsResponseSchema as xt, listAttachmentDescriptionsResponseSchema as y, getOperatorFilterValuesResponseSchema as yt, getRequestsQueryUpdatedFromSchema as z, getCountsStatus200Schema as zt };

//# sourceMappingURL=updateDraftSchema.js.map